
import {defineComponent, onMounted, reactive, toRefs} from 'vue'
import {useRoute} from "vue-router";

export default defineComponent({
  components: {
  },
  setup() {
    const route = useRoute()

    const state = reactive({

    });

    const redirect = (links: any, timeout = 500) => {
      links.forEach((link: string, index: number) => {
        setTimeout(() => {
          console.log("redirect to " + link)
          window.location.href = link;
        }, index * timeout);
      });
    }

    const decode = async (input: string) => {
      const unZip = async (arr: any) => {
        const decompressor = new (window as any).DecompressionStream("deflate-raw")
        const stream = new Response(arr)?.body?.pipeThrough(decompressor);
        return await new Response(stream).text();
      };

      let base64 = input.replace(/-/g, "+").replace(/_/g, "/");
      while (base64.length % 4 !== 0) {
        base64 += "=";
      }

      const bin = atob(base64);
      const arr = Uint8Array.from(bin, (c) => c.charCodeAt(0));
      const txt = await unZip(arr)
      return JSON.parse(txt);
    };

    onMounted(async () => {
      if (!route.query.l) {
        return;
      }

      setTimeout(() => {
        window.close();
      }, 20000);

      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const links = await decode(route.query.l as string) as any
      if (isIOS) {
        return redirect(links['ios'])
      }

      return redirect(links['android'])
    });

    return {
      ...toRefs(state),
    }
  }
})
